import { blockNoteToPlainText } from "../../../shared/utils/blockNote";

/**
 * Rules about what session notes must contain. Business rules, not
 * presentation: the notes step reads them to tell the therapist what the
 * analysis needs, but they are true whether or not anything renders them.
 *
 * Both values mirror the backend, which stays the authority:
 * - `backend/app/domain/services/sessions/notes_text.py::MIN_ANALYSIS_WORDS`
 * - `backend/app/domain/services/sessions/image_normalizer.py::MAX_IMAGE_BYTES`
 */

/** Words of notes the AI analysis needs before it will run. */
export const MIN_ANALYSIS_WORDS = 150;

/** Largest session-notes image the upload accepts. */
export const MAX_IMAGE_BYTES = 10 * 1024 * 1024; // 10 MB

/**
 * Count the words a therapist can actually see in the notes.
 *
 * The editor persists BlockNote JSON, and `JSON.stringify` emits no whitespace
 * outside the typed text — so counting whitespace tokens of the raw value
 * scores an empty document as 1 and only moves when a space is typed. The
 * value is normalised to plain text first, which also covers the legacy HTML
 * and plain-text notes still in the database.
 */
export function countNoteWords(notes: string): number {
    if (!notes) return 0;
    return blockNoteToPlainText(notes).split(/\s+/).filter(Boolean).length;
}

/** Whether the notes carry enough text for the analysis to run. */
export function hasEnoughForAnalysis(notes: string): boolean {
    return countNoteWords(notes) >= MIN_ANALYSIS_WORDS;
}
